// @core/api/endpoints/form/create_form.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateFormRequest,
  FormResponse,
} from '../../../types/form';

const BASE_PATH = '/form';

/**
 * Create a new form
 * Creates a new form in draft status. Add pages and fields after creation.
 */
export async function CreateForm(
  data: CreateFormRequest,
  options?: RequestOptions
): Promise<FormResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/forms`;
  const requestOptions = options;
  return client.post<FormResponse>(requestPath, data, requestOptions);
}
